import { render, staticRenderFns } from "./AddPet.vue?vue&type=template&id=58d14eb2&scoped=true&"
import script from "./AddPet.vue?vue&type=script&lang=js&"
export * from "./AddPet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d14eb2",
  null
  
)

export default component.exports